import apiClient from './apiClient';

// FOLLOW-UP v1
export async function getFollowUpsLatest() {
  const res = await apiClient.get('/follow-ups/latest');
  return res.data.data;
}

export async function getCustomerFollowUps(customerId) {
  const res = await apiClient.get(`/follow-ups/customer/${customerId}`);
  return res.data.data.items;
}

export async function addFollowUp({ customerId, outcome, note, snoozeDays }) {
  const body = { customerId, outcome, note };
  if (snoozeDays !== undefined) body.snoozeDays = snoozeDays;
  const res = await apiClient.post('/follow-ups', body);
  return res.data.data;
}

// FOLLOW-EDIT v1
export async function updateFollowUp(id, { outcome, note, snoozeDays }) {
  const body = { outcome, note };
  if (snoozeDays !== undefined) body.snoozeDays = snoozeDays;
  const res = await apiClient.put(`/follow-ups/${id}`, body);
  return res.data.data;
}

export async function deleteFollowUp(id) {
  const res = await apiClient.delete(`/follow-ups/${id}`);
  return res.data.data;
}
